export const version = `1.5.0`;
export const versionWithBuild = `1.5.0-27`;
